import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import Spinner from "./Spinner";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OverlaySpinner = _ref => {
  let {
    animationTimeout = 500,
    description = '',
    show = false,
    text = 'Submitting...'
  } = _ref;
  return /*#__PURE__*/_jsx(TransitionGroup, {
    className: "overlay",
    children: show && /*#__PURE__*/_jsx(CSSTransition, {
      classNames: "overlay",
      className: "overlay-spinner",
      timeout: {
        enter: animationTimeout,
        exit: animationTimeout
      },
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "overlay-spinner__text-container",
          children: [/*#__PURE__*/_jsx("p", {
            className: "overlay-spinner__text",
            children: text
          }), description && /*#__PURE__*/_jsx("p", {
            className: "overlay-spinner__description",
            children: description
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "overlay-spinner__options",
          children: /*#__PURE__*/_jsx(Spinner, {})
        })]
      })
    })
  });
};
OverlaySpinner.propTypes = {
  animationTimeout: PropTypes.number,
  description: PropTypes.string,
  show: PropTypes.bool,
  text: PropTypes.string
};
export default OverlaySpinner;
//# sourceMappingURL=OverlaySpinner.js.map